import React from 'react';
import { Destination, MediaAsset, RecommendedExperience, RouteHighlight } from '../../types/Destination';

type Props = {
  destination: Destination;
  onClose: () => void;
};

const DestinationDetailsModal: React.FC<Props> = ({ destination, onClose }) => (
  <div className="destination-modal-backdrop" onClick={onClose}>
    <div className="destination-modal" onClick={(e) => e.stopPropagation()}>
      <header className="destination-modal-header">
        <h3>{destination.title}</h3>
        <button className="close-modal-btn" onClick={onClose} type="button">
          x
        </button>
      </header>

      <section className="destination-modal-body">
        <img
          src={destination.hero.image.src}
          alt={destination.hero.image.alt}
          className="destination-modal-hero"
        />
        <p className="destination-modal-description">{destination.summary}</p>

        {!!destination.gallery.length && (
          <div>
            <h4>Gallery</h4>
            <div className="destination-gallery-grid">
              {destination.gallery.map((image: MediaAsset, idx: number) => (
                <img src={image.src} alt={image.alt || `${destination.title} gallery ${idx + 1}`} key={`${image.src}-${idx}`} />
              ))}
            </div>
          </div>
        )}

        {!!destination.recommendedExperiences.length && (
          <div>
            <h4>Recommended Experiences</h4>
            <div className="destination-attractions-grid">
              {destination.recommendedExperiences.map((experience: RecommendedExperience) => (
                <div className="destination-attraction-card" key={experience.title}>
                  {experience.image?.src ? (
                    <img src={experience.image.src} alt={experience.image.alt || experience.title} />
                  ) : null}
                  <div>
                    <p className="destination-attraction-name">{experience.title}</p>
                    {experience.description && <p>{experience.description}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {!!destination.routeHighlights?.length && (
          <div>
            <h4>Route Highlights</h4>
            <div className="destination-travel-grid">
              {destination.routeHighlights.map((segment: RouteHighlight) => (
                <div className="travel-option-card" key={`${segment.stopLabel}-${segment.title}`}>
                  <h5>{segment.stopLabel}</h5>
                  <p>{segment.title}</p>
                  {segment.description && <p>{segment.description}</p>}
                </div>
              ))}
            </div>
          </div>
        )}
      </section>
    </div>
  </div>
);

export default DestinationDetailsModal;
